export default __webpack_public_path__ + "static/media/partner-datacom.81feb8cd.png";